export enum PinnerTabs {
    PLACE = 'place',
    PINNER = 'pinner'
}